// extracted by mini-css-extract-plugin
export default {"devPortalTypeahead":"filter-style-module__devPortalTypeahead__XyN17"};